/** @format */

import React, { FC, useState, useEffect, useMemo } from 'react'
import { _$, Button, ButtonGroup, Select, Option, Badge } from 'kpc-react'
import styled from 'styled-components'
import useGlobalData from 'src/hooks/useGlobalData'
import { RegionStateType } from 'src/store/globalDataSlice'
import { request } from 'src/utils'
import Cookie from 'js-cookie'
interface RegionBtnProps {
  className?: string
  buttonCount?: number
  regionChange: (val: string) => void
  defaultValue?: string
  isUpdate?: boolean
  api?: string
  apiData?: any
  regionBadge?: {
    [key: string]: number
  }
}

const lang = Cookie.get('ksc_lang')
const RegionBtn: FC<RegionBtnProps> = ({
  className,
  regionChange,
  buttonCount = 5,
  defaultValue,
  api,
  apiData,
  regionBadge,
  isUpdate = true
}) => {
  // regionValue，没有初始值的话从localStorage拿初始值
  const [value, setValue] = useState(defaultValue || localStorage.getItem('systemId'))
  // regionList（渲染）
  const [regionList, setRegionList] = useState<RegionStateType['list']>([])
  // 如果没有传api就请求公共的regionList
  const gloabalRegionList = !api && (useGlobalData('monitorRegionList') as RegionStateType['list'])

  // 初始化判断是否单独传了api
  useEffect(() => {
    api && getRegionListFromApi()
  }, [api])

  // setRegionList(公共regionList)
  useEffect(() => {
    gloabalRegionList?.length && setRegionList(gloabalRegionList)
  }, [gloabalRegionList])

  // regionList变化时
  // 如果localStorage中没有regionKey就把regionList中第一个设置成默认值
  useEffect(() => {
    if (regionList.length) {
      const find = regionList.find(({ regionKey }) => regionKey === value)
      if (!value || value === 'null' || !find) {
        const regionFirstKey = regionList[0].regionKey
        if (isUpdate) {
          localStorage.setItem('systemId', regionFirstKey)
        }
        setValue(regionFirstKey)
        handleChange(regionFirstKey)
      } else {
        handleChange(value)
      }
    }
  }, [regionList])

  // 通过api请求regionList
  const getRegionListFromApi = async () => {
    const result = await request(api, {
      data: {},
      method: 'GET',
      ...apiData
    })
    setRegionList(result?.data || [])
  }

  // 切换region时
  const handleChange = regionKey => {
    setValue(regionKey)
    if (isUpdate) {
      localStorage.setItem('systemId', regionKey)
    }
    regionChange && regionChange(regionKey)
  }

  // 计算select value的徽标
  const calcSelectBadge = useMemo(() => {
    if (value && regionList?.length) {
      const curRegion = regionList.slice(buttonCount).find(({ regionKey }) => regionKey === value)
      if (curRegion) {
        return regionBadge?.[curRegion?.regionKey] || false
      } else {
        return false
      }
    } else {
      return false
    }
  }, [value, regionList])

  return (
    <div className={className}>
      <ButtonGroup checkType="radio" value={value}>
        {regionList?.length
          ? regionList.slice(0, buttonCount).map(({ regionKey, regionName }, index) => {
              const badgeCount = regionBadge?.[regionKey] || false
              return (
                <Badge key={regionKey} disabled={!badgeCount} text={badgeCount || ''} max={99}>
                  <Button
                    className={
                      regionList.length > buttonCount && index === buttonCount - 1 ? 'last_btn' : ''
                    }
                    onClick={() => {
                      handleChange(regionKey)
                    }}
                    value={regionKey}
                  >
                    {lang === 'en' ? regionKey : regionName}
                  </Button>
                </Badge>
              )
            })
          : null}
      </ButtonGroup>
      {regionList && regionList.length > buttonCount ? (
        <Badge disabled={!calcSelectBadge} text={calcSelectBadge || ''} max={99}>
          <Select
            className={
              regionList.slice(buttonCount).find(({ regionKey }) => regionKey === value)
                ? 'select-active'
                : ''
            }
            width={140}
            placeholder={_$('更多机房')}
            value={value}
            onChange={val => {
              handleChange(val)
            }}
          >
            {regionList.slice(buttonCount).map(({ regionKey, regionName }) => (
              <Option key={regionKey} value={regionKey}>
                {lang === 'en' ? regionKey : regionName}
              </Option>
            ))}
          </Select>
        </Badge>
      ) : null}
    </div>
  )
}

export default styled(RegionBtn)`
  .k-select .k-wrapper {
    margin-left: -1px;
    border-radius: 0 0.25rem 0.25rem 0;
  }
  .select-active .k-wrapper {
    background-color: #e5f7ff;
    color: #0091ea;
    border-color: #0091ea;
  }
  .k-badge .k-text {
    z-index: 9;
  }
  .k-btns:not(.k-vertical) .k-btn:not(:only-child):last-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .k-btns:not(.k-vertical) .k-btn:not(:first-child):not(:last-child) {
    border-radius: 0;
  }
  .k-btns:not(.k-vertical) .k-badge:not(:first-child) {
    margin-left: -1px;
  }
  .k-select .k-wrapper {
    border-radius: 0.125rem;
  }
`
